import {
  ADD_POLICY,
  ADD_POLICY_ERROR,
  ADD_POLICY_SUCCESS,
  GET_POLICY,
  GET_POLICIES,
  GET_POLICIES_ERROR,
  GET_POLICIES_SUCCESS,
  GET_POLICY_ERROR,
  GET_POLICY_SUCCESS,
  TOGGLE_POLICY_MODAL,
  UPDATE_POLICY,
  UPDATE_POLICY_ERROR,
  UPDATE_POLICY_SUCCESS,
  GET_DEFAULT_POLICY,
  GET_DEFAULT_POLICY_SUCCESS,
  GET_DEFAULT_POLICY_ERROR,
} from "./actionTypes";

const initialState = {
  // policies
  loadingPolicies: false,
  loadingPoliciesSuccess: false,
  loadingPoliciesError: null,
  policies: {},
  // add policy
  policy: {},
  addPolicyLoading: false,
  addPolicyError: null,
  addPolicySuccess: false,
  // get policy
  getPolicyLoading: false,
  getPolicyError: null,
  getPolicySuccess: null,
  // update policy
  updatePolicyLoading: false,
  updatePolicyError: null,
  updatePolicySuccess: null,
  // select list
  policiesSelectList: [],
  defaultPolicy: {},
  loadingDefaultPolicy: false,
  loadingDefaultPolicySuccess: false,
  loadingDefaultPolicyError: null,
};

const policies = (state = initialState, action) => {
  switch (action.type) {
    case GET_POLICIES:
      state = {
        ...state,
        addPolicySuccess: false,
        updatePolicySuccess: false,
        loadingPolicies: true,
        loadingPoliciesSuccess: false,
        loadingPoliciesError: null,
        policies: [],
        policy: {},
      };
      break;
    case GET_POLICIES_SUCCESS:
      state = {
        ...state,
        loadingPolicies: false,
        loadingPoliciesSuccess: true,
        loadingPoliciesError: null,
        policies: action.payload,
      };
      break;
    case GET_POLICIES_ERROR:
      state = {
        ...state,
        loadingPoliciesError: action.payload,
        loadingPolicies: false,
        loadingPoliciesSuccess: false,
        policies: [],
      };
      break;
    case ADD_POLICY:
      state = {
        ...state,
        addPolicyLoading: true,
        addPolicyError: null,
        addPolicySuccess: false,
      };
      break;
    case ADD_POLICY_SUCCESS:
      state = {
        ...state,
        addPolicyLoading: false,
        addPolicyError: null,
        addPolicySuccess: true,
        policy: {},
      };
      break;
    case ADD_POLICY_ERROR:
      state = {
        ...state,
        addPolicyLoading: false,
        addPolicyError: action.payload,
        addPolicySuccess: false,
      };
      break;
    case GET_POLICY:
      state = {
        ...state,
        policy: {},
        getPolicyLoading: true,
        getPolicySuccess: false,
        getPolicyError: null,
      };
      break;
    case GET_POLICY_SUCCESS:
      state = {
        ...state,
        getPolicyError: null,
        getPolicySuccess: true,
        getPolicyLoading: false,
        policy: action.payload,
      };
      break;
    case GET_POLICY_ERROR:
      state = {
        ...state,
        getPolicyError: action.payload,
        getPolicyLoading: false,
        getPolicySuccess: false,
      };
      break;
    case GET_DEFAULT_POLICY:
      state = {
        ...state,
        defaultPolicy: {},
        loadingDefaultPolicy: true,
        loadingDefaultPolicySuccess: false,
        loadingDefaultPolicyError: null,
      };
      break;
    case GET_DEFAULT_POLICY_SUCCESS:
      state = {
        ...state,
        loadingDefaultPolicyError: null,
        loadingDefaultPolicySuccess: true,
        loadingDefaultPolicy: false,
        defaultPolicy: action.payload,
      };
      break;
    case GET_DEFAULT_POLICY_ERROR:
      state = {
        ...state,
        loadingDefaultPolicyError: action.payload,
        loadingDefaultPolicy: false,
        loadingPoliciesSuccess: false,
      };
      break;
    case UPDATE_POLICY:
      state = {
        ...state,
        updatePolicyLoading: true,
        updatePolicyError: null,
        updatePolicySuccess: false,
      };
      break;
    case UPDATE_POLICY_SUCCESS:
      state = {
        ...state,
        updatePolicyLoading: false,
        updatePolicyError: null,
        updatePolicySuccess: true,
      };
      break;
    case UPDATE_POLICY_ERROR:
      state = {
        ...state,
        updatePolicyLoading: false,
        updatePolicyError: action.payload,
        updatePolicySuccess: false,
        policy: {},
      };
      break;
    case TOGGLE_POLICY_MODAL:
      state = {
        ...state,
        policy: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default policies;
